import { Box, Typography } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import { ProPage } from '../../components/PlanCheck/PlanCheckPage';
import { t } from '../../constants/translations';
import { useAdmin } from '../../contexts/admin.context';
import { useCafe } from '../../contexts/cafe.context';
import { useLocale } from '../../contexts/locale.context';
import Orders from './Orders';
import PoinsList from './PoinsList';
import OpenShiftButton from './ShiftButtons/OpenShiftButton';
import TablesMap from './TablesMap';

const POS = () => {
  const { tablesMap, cafe } = useAdmin();
  const { currentPosShift } = useCafe();
  const { lang } = useLocale();

  if (cafe?.posShifts && !currentPosShift) {
    return (
      <Box sx={{ m: 4 }}>
        <Typography variant="h6" align="center">
          {t.shift_not_open[lang]}
        </Typography>

        <Box sx={{ textAlign: 'center', my: 2 }}>
          <OpenShiftButton />
        </Box>
      </Box>
    );
  }

  return (
    <Routes>
      {cafe?.type === 'selfOrderPoins' && <Route path="/" element={<PoinsList />} />}
      {cafe?.type !== 'selfOrderPoins' && (
        <Route path="/" element={tablesMap.enabled && tablesMap.tables.length > 0 ? <TablesMap /> : <Orders />} />
      )}
      <Route path="orders" element={<Orders />} />
      <Route
        path="delivery"
        element={
          <ProPage>
            <Orders isDelivery />
          </ProPage>
        }
      />
    </Routes>
  );
};

export default POS;
